import React, { useMemo } from 'react'

import { useField } from '../../../../../1stlog-ui/src/components/Field'

export type TOrderEntryTransport = {
  isMixedTransport?: boolean
  requirePickupProduct?: boolean
  requireDeliveryProduct?: boolean
}

const useTransport = (): TOrderEntryTransport => {
  const isPickup = useField('isPickup', { ignorePrefix: true })
  const isDelivery = useField('isDelivery', { ignorePrefix: true })

  const pickupTime = useField('delivery.pickupTime.selectedTime', {
    ignorePrefix: true,
  })
  const deliveryTime = useField('pickup.deliveryTime.selectedTime', {
    ignorePrefix: true,
  })

  const requirePickupProduct = useMemo(
    () => pickupTime === 'ownArea',
    [pickupTime],
  )
  const requireDeliveryProduct = useMemo(
    () => deliveryTime === 'ownArea',
    [deliveryTime],
  )

  const isMixedTransport = useMemo(
    () => isPickup && isDelivery,
    [isPickup, isDelivery],
  )

  return { isMixedTransport, requirePickupProduct, requireDeliveryProduct }
}

export default useTransport
